import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const header = css`
  block-size: unset;
  margin-block-end: ${spacing(0.75)};
`
